const AUTO_SAVE_TIMER = 10;

export { AUTO_SAVE_TIMER };
